import { toast } from "sonner";
import { Mail } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const ChatEmailToggle = () => {
  const { user, setUser } = useAuth();
  const on = user.chat_emails !== false;
  const change = async (value) => {
    try {
      await api.put("/me/chat-emails", { value });
      setUser({ ...user, chat_emails: value });
      toast.success(value ? "Avvisi email attivati" : "Avvisi email disattivati");
    } catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <label className="mt-10 flex items-center justify-between gap-6 border border-white/10 bg-[#121418] px-6 py-5 cursor-pointer" data-testid="chat-email-toggle">
      <span className="flex items-start gap-3">
        <Mail className="w-4 h-4 text-[#D4AF37] mt-0.5" />
        <span>
          <span className="block text-sm text-neutral-200">Avvisi email per i nuovi messaggi</span>
          <span className="block text-xs text-neutral-500 mt-1">Ti scriviamo a {user.email} quando ricevi un messaggio e non sei sull'app.</span>
        </span>
      </span>
      <Switch checked={on} onCheckedChange={change} data-testid="chat-email-switch" />
    </label>
  );
};
